export default __webpack_public_path__ + "static/media/medaille-bdo-bronze-realisation.5bf1c126.png";